<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-03 10:56:19
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-19 17:42:10
 * @Description: 合作伙伴
 -->
<template>
  <div class="partner-wrapper">
    <h3 class="title">合作伙伴</h3>
    <ul class="icon-wrapper">
      <li>
        <img src="https://files.jinr.com/jinr-index/img/index-partner-01.png" alt="" srcset="" />
      </li>
      <!-- <li>
        <img src="https://files.jinr.com/jinr-index/img/index-partner-02.png" alt="" srcset="" />
      </li> -->
      <li>
        <img
          src="https://files.jinr.com/jinr-index/img/index-partner-03.png"
          alt=""
          srcset=""
          class="special"
        />
      </li>
      <li>
        <img src="https://files.jinr.com/jinr-index/img/index-partner-04.png" alt="" srcset="" />
      </li>
      <li>
        <img
          src="https://files.jinr.com/jinr-index/img/index-partner-05.png"
          alt=""
          srcset=""
          class="special"
        />
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'partner'
};
</script>
<style lang="less" scoped>
.partner-wrapper {
  background: #fff;
  padding: 44px 0 66px;
  .title {
    width: 100%;
    margin: 0 auto;
    font-family: 'PingFangSC-Medium';
    font-size: 22px;
    color: #333333;
    text-align: center;
  }
  .icon-wrapper {
    display: flex;
    width: 1200px;
    margin: 64px auto 0;
    padding: 0 120px;
    justify-content: space-around;
    align-items: center;
    box-sizing: border-box;
    img {
      height: 50px;
    }
    .special {
      height: 30px;
    }
  }
}
</style>
